import { Box, Typography } from '@mui/material';
import { Title } from './section';

function HMO2025() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        border: '1px solid #FFFFFF',
        width: { xs: '100%', sm: '268px' },
        height: '70px',
        maxWidth: { xs: '350px', sm: '268px' }
      }}
    >
      <img
        style={{
          marginTop: '10px',
          marginLeft: '10px',
          marginRight: '10px',
          width: '50px',
          height: '50px'
        }}
        src="/assets/awards/hmo2025.svg"
        alt="HMO2025"
      />
      <Box>
        <Typography
          sx={{
            fontFamily: 'Atkinson Hyperlegible',
            fontWeight: 700,
            fontStyle: 'Bold',
            fontSize: '14px',
            leadingTrim: 'NONE',
            lineHeight: '100%',
            letterSpacing: '0%',
            marginTop: '14px'
          }}
        >
          Best Technology Provider
        </Typography>
        <Box
          sx={{
            display: 'flex',
            direction: 'row',
            alignItems: 'center',
            marginTop: '10px'
          }}
          gap={1}
        >
          <Typography
            sx={{
              fontFamily: 'Manrope',
              fontWeight: 400,
              fontStyle: 'Regular',
              fontSize: '12px',
              leadingTrim: 'NONE',
              lineHeight: '100%',
              letterSpacing: '0%'
            }}
          >
            Highly Commended
          </Typography>
          <img src="/assets/awards/rate.svg" alt="rate" />
        </Box>
      </Box>
    </Box>
  );
}
function CambridgeUniversity2025() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        border: '1px solid #FFFFFF',
        width: { xs: '100%', sm: '305px' },
        height: '70px',
        maxWidth: { xs: '350px', sm: '305px' }
      }}
    >
      <img
        style={{
          marginTop: '10px',
          marginLeft: '10px',
          marginRight: '10px',
          width: '50px',
          height: '50px'
        }}
        src="/assets/awards/cambridge2025.svg"
        alt="Cambridge Global Consulting"
      />
      <Box>
        <Typography
          sx={{
            fontFamily: 'Atkinson Hyperlegible',
            fontWeight: 700,
            fontStyle: 'Bold',
            fontSize: '14px',
            leadingTrim: 'NONE',
            lineHeight: '100%',
            letterSpacing: '0%',
            marginTop: '14px'
          }}
        >
          Cambridge Global Consulting
        </Typography>
        <Box
          sx={{
            display: 'flex',
            direction: 'row',
            alignItems: 'center',
            marginTop: '3px'
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: 'Manrope',
                fontWeight: 400,
                fontStyle: 'Regular',
                fontSize: '11px',
                leadingTrim: 'NONE',
                lineHeight: '100%',
                letterSpacing: '0%'
              }}
            >
              Silk Road Talent Investment
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Manrope',
                fontWeight: 400,
                fontStyle: 'Regular',
                fontSize: '11px',
                leadingTrim: 'NONE',
                lineHeight: '100%',
                letterSpacing: '0%'
              }}
            >
              Competition 8th Talent Conference
            </Typography>
          </Box>
          <img
            style={{ marginLeft: '3px' }}
            src="/assets/awards/prize.svg"
            alt="rate"
          />
        </Box>
      </Box>
    </Box>
  );
}
function UKEDGE2025() {
  return (
    <Box
      sx={{
        border: '1px solid #FFFFFF',
        width: { xs: '100%', sm: '180px' },
        height: '70px',
        maxWidth: { xs: '350px', sm: '180px' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src="/assets/awards/UKEDGE2025.svg"
        alt="UK EDGE 2025"
        style={{ height: '40px', marginTop: '5px' }}
      />
      <Typography
        sx={{
          fontFamily: 'Atkinson Hyperlegible',
          fontWeight: 700,
          fontStyle: 'Italic',
          fontSize: '12px',
          leadingTrim: 'NONE',
          lineHeight: '100%',
          letterSpacing: '0%',
          marginTop: '5px'
        }}
      >
        Innovate UK EDGE
      </Typography>
    </Box>
  );
}
function GrowthHub2025() {
  return (
    <Box
      sx={{
        border: '1px solid #FFFFFF',
        width: { xs: '100%', sm: '268px' },
        height: '70px',
        maxWidth: { xs: '350px', sm: '268px' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <img
          style={{
            marginTop: '5px',
            marginLeft: '10px',
            marginRight: '10px',
            height: '40px'
          }}
          src="/assets/awards/growth-hub-1.svg"
          alt=""
        />
        <img
          style={{
            marginTop: '5px',
            marginLeft: '10px',
            marginRight: '10px',
            height: '40px'
          }}
          src="/assets/awards/growth-hub-2.svg"
          alt=""
        />
      </Box>
      <Typography
        sx={{
          fontFamily: 'Atkinson Hyperlegible',
          fontWeight: 700,
          fontStyle: 'Bold',
          fontSize: '14px',
          leadingTrim: 'NONE',
          lineHeight: '100%',
          letterSpacing: '0%',
          marginTop: '5px'
        }}
      >
        Business Innovation Fund
      </Typography>
    </Box>
  );
}
export default function Awards() {
  return (
    <Box sx={{ marginTop: '100px' }}>
      <Title
        text="A list of awards"
        className="mx-auto w-full max-w-screen-lg font-medium"
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 1, md: 2 },
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: { xs: '50px', md: '100px' },
          padding: { xs: '0 16px', md: '0' },
          flexWrap: 'wrap'
        }}
      >
        <HMO2025 />
        <CambridgeUniversity2025 />
        <UKEDGE2025 />
        <GrowthHub2025 />
      </Box>
    </Box>
  );
}
